import { render, staticRenderFns } from "./TabelaAvaliacaoTreinamento.vue?vue&type=template&id=f14bec78&scoped=true"
import script from "./TabelaAvaliacaoTreinamento.vue?vue&type=script&lang=js"
export * from "./TabelaAvaliacaoTreinamento.vue?vue&type=script&lang=js"
import style0 from "./TabelaAvaliacaoTreinamento.vue?vue&type=style&index=0&id=f14bec78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14bec78",
  null
  
)

export default component.exports